import { render, staticRenderFns } from "./RegistrationModule.vue?vue&type=template&id=dd2fb3a2&scoped=true&"
import script from "./RegistrationModule.vue?vue&type=script&lang=js&"
export * from "./RegistrationModule.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationModule.vue?vue&type=style&index=0&id=dd2fb3a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2fb3a2",
  null
  
)

export default component.exports